<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <app-primary-button (handleClick)="create()" class="!w-[150px]"> Create </app-primary-button>
  </div>

  <div class="list-section">
    <div class="sites-list-table flex flex-col gap-[40px]">
      @if (dataSource?.length) {
        <div class="bit-items-table">
          <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
            <ng-container matColumnDef="name">
              <th *matHeaderCellDef mat-header-cell>Name</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.name }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="description">
              <th *matHeaderCellDef mat-header-cell>Description</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.description }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="progress">
              <th *matHeaderCellDef mat-header-cell>Progress</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.progressText || '0 / 0 days' }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="site_value">
              <th *matHeaderCellDef mat-header-cell>Site value</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">
                  @if (row?.site_value) {
                    <span>$ {{ row?.site_value | number : '1.2-2' }}</span>
                  }
                  @if (!row?.site_value) {
                    <span>-</span>
                  }
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th *matHeaderCellDef mat-header-cell></th>
              <td *matCellDef="let row" mat-cell>
                <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="deleteSite(row, $event)">
                    <mat-icon svgIcon="trash"></mat-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr
              (click)="rowClicked(row)"
              *matRowDef="let row; columns: displayedColumns"
              [class.highlighted-row]="row === selectedRow"
              mat-row
            ></tr>
          </table>
        </div>
      }

      @if (!dataSource?.length) {
        <div class="no-data mt-[80px]">No data available.</div>
      }

      @if (totalRecords > 0) {
        <app-paginator
          (pageChanged)="onPageChanged($event)"
          [itemsPerPage]="pagination?.pageSize"
          [maxVisiblePages]="5"
          [totalItems]="totalRecords"
          class="paginator"
          />
      }
    </div>
  </div>
</div>
